import { useEffect, useRef, useState } from "react";
import Modal from "../UI/Modal";
import { SketchPicker } from "react-color";
import classes from "./ColorPickerDialog.module.css";

// props.onClose(color) = Dialog closed
// props.color = the starting color
const ColorPickerDialog = (props) => {
  const [color, setColor] = useState(props.color);
  const dialog = useRef(null);

  // Ear Trainer opts into keyboard dismissal and a local focus trap. Other
  // callers retain their existing picker presentation.
  useEffect(() => {
    if (!props.accessibleLabel) return;
    const opener = document.activeElement;
    dialog.current.querySelector("input, button")?.focus();
    return () => { if (opener?.isConnected) opener.focus({ preventScroll: true }); };
  }, [props.accessibleLabel]);

  const onChangeCompleteHandler = (incolor) => {
    setColor(incolor.hex);
  };

  const onClose = () => {
    props.onClose(color);
  };

  const onKeyDown = event => {
    if (event.key === "Escape") {
      event.preventDefault(); event.stopPropagation(); onClose();
    } else if (event.key === "Tab") {
      const controls = [...dialog.current.querySelectorAll("input, button, [tabindex]")]
        .filter(element => !element.disabled && element.tabIndex >= 0);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  };

  const picker = <SketchPicker disableAlpha={true} color={color} onChangeComplete={onChangeCompleteHandler} />;

  return (
    <Modal onClose={onClose}>
      {props.accessibleLabel ? <div ref={dialog} role="dialog" aria-modal="true"
        aria-label={props.accessibleLabel} className={classes.accessibleDialog} onKeyDown={onKeyDown}>
        {picker}
        <button type="button" onClick={onClose}>Done</button>
      </div> : picker}
    </Modal>
  );
};

export default ColorPickerDialog;
